import { Injectable, inject } from '@angular/core';

import { SecurityRouterStoreSelectors, UserGroupStoreActions } from '@era/stores';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UserGroupResolver {
  private readonly store = inject(Store);

  resolve(): Observable<boolean> {
    return this.store.select(SecurityRouterStoreSelectors.selectCurrentUserId).pipe(
      filter((x: string) => x !== undefined),
      tap((x: string) => {
        this.store.dispatch(UserGroupStoreActions.UserGroupResolverActions.userGroupsRequested({ userId: x }));
      }),
      map(() => true),
      first()
    );
  }
}
